import {useQuery} from '@tanstack/react-query';

import {getTopic} from '../api';
import {QUERY__TOPIC} from '../queryKeys';
import {Topic} from '../types';

import {QueryOptionsForOne} from '@/shared/api';

export const useGetTopic = <SelectedData = Topic>(
  id: string,
  options?: QueryOptionsForOne<Topic, SelectedData>,
) => {
  return useQuery({
    queryKey: [QUERY__TOPIC, id],
    queryFn: () => getTopic(id),
    ...options,
  });
};
